import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Trophy,
  Settings,
  Activity,
  FileText,
  Zap,
  Mail,
  Wrench,
  ArrowLeft,
} from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const NAV_ITEMS = [
  { label: 'Dashboard', path: '/admin', icon: LayoutDashboard, end: true },
  { label: 'Leagues', path: '/admin/leagues', icon: Trophy },
  { label: 'Platform Settings', path: '/admin/settings', icon: Settings },
  { label: 'Global Tools', path: '/admin/tools', icon: Wrench },
  { label: 'Operations', path: '/admin/operations', icon: Zap },
  { label: 'Logs', path: '/admin/logs', icon: FileText },
  { label: 'Activity', path: '/admin/activity', icon: Activity },
  { label: 'Emails', path: '/admin/emails', icon: Mail },
];

export function AdminSidebar() {
  const { user } = useAuth();

  return (
    <aside className="fixed inset-y-0 left-0 z-40 flex w-56 flex-col bg-zinc-900 text-zinc-100">
      <div className="flex h-14 items-center gap-2 border-b border-zinc-800 px-4">
        <span className="text-sm font-semibold tracking-wide">Socrates Admin</span>
      </div>

      <nav className="flex-1 overflow-y-auto px-2 py-3 space-y-0.5">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            className={({ isActive }) =>
              `flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm transition-colors ${
                isActive
                  ? 'bg-zinc-800 text-white font-medium'
                  : 'text-zinc-400 hover:bg-zinc-800/60 hover:text-zinc-200'
              }`
            }
          >
            <item.icon className="h-4 w-4 shrink-0" />
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-zinc-800 px-4 py-3 space-y-2">
        <p className="truncate text-xs text-zinc-500">{user?.email}</p>
        <NavLink
          to="/dashboard"
          className="flex items-center gap-2 text-xs text-zinc-500 hover:text-zinc-300 transition-colors"
        >
          <ArrowLeft className="h-3 w-3" />
          Back to App
        </NavLink>
      </div>
    </aside>
  );
}
